export enum ColorOptions {
	White = 'white',
	WhiteGrey = 'whiteGrey',
	LightGrey = 'lightGrey',
	LightBlue = 'lightBlue',

	Blue = 'blue',
	Green = 'green',
	Red = 'red',
	Violet = 'violet',
}
export default ColorOptions;

export interface LinkType {
	url: string;
	name?: string;
	target?: string;
}

export enum GridLayoutTypeOptions {
	OneThirdImage = 'oneThirdImage',
	HalfImage = 'halfImage',
	TwoThirdsImage = 'twoThirdsImage',
}

export enum LightBgColor {
	LightBlue = 'lightBlue',
	Lilac = 'lilac',
	Turqoise = 'turqoise',
	Grey = 'grey',
	Sand = 'sand',
	Pink = 'pink',
}
